

import React, { memo, useMemo } from 'react';

import { getOutputSummaryWithAdditionalOutputs } from '@shootsta/addons-summarizer';
import BasicAddonsList from '../BasicAddonsList';
import '../../styles/_addons-list.scss';













function OutputAddonsList({
  videoOutput,
  additionalOutputs = [],
  addonsSelector = 'appliedAddons',
  noAddonsMessage,
  isAddonDescriptionWrapped,
  onChangeAddonStatus,
  shouldShowActions = false,
  isBrief,
  isNewDesign
}) {
  const { addonsList } = useMemo(
    () => getOutputSummaryWithAdditionalOutputs(
      videoOutput, additionalOutputs, addonsSelector, isBrief
    ),
    [videoOutput, additionalOutputs, addonsSelector, isBrief]
  );

  return (
    <BasicAddonsList
      addonsList={addonsList}
      noAddonsMessage={noAddonsMessage}
      isAddonDescriptionWrapped={isAddonDescriptionWrapped}
      onChangeAddonStatus={onChangeAddonStatus}
      shouldShowActions={shouldShowActions}
      isNewDesign={isNewDesign} />);


}

export default memo(OutputAddonsList);